export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Body_Leading-f661be8d281f7b20227d492725efd21d.svg";